// @noflow
import { Frost, PickerContainer } from './style';

import { getColour } from '~/core/utils/colour';
import * as React from 'react';
import { TemperatureSpinnerFull, Temperature } from '~/components/widgets';

export const getValueColor = ({ value }) => {
    return getColour(value.get('target', 5));
};

export const getValueLabel = ({ value, productState }) => {
    const temp = value.get('target', 5);
    const frostProtection = productState.get('frostProtection', 7);
    return frostProtection && temp === frostProtection ? (
        <Frost dy="10">N</Frost>
    ) : (
        <Temperature element="tspan" value={temp} />
    );
};

export const hasPicker = () => true;

export const getPicker = ({ config, productState, value, updateValue }) => {
    const temp = value.get('target', 5);
    const frostValue = productState.get('frostProtection', 7);
    return (
        <PickerContainer>
            <TemperatureSpinnerFull
                currentTemp={temp}
                frostProtectionValue={frostValue}
                handleChangeTemp={newTarget => updateValue(value.set('target', newTarget))}
                interval={0.5}
                maxTemp={config.getIn(['products', 'heating', 'maxTemp'], 32)}
                minTemp={config.getIn(['products', 'heating', 'minTemp'], 5)}
            />
        </PickerContainer>
    );
};

export const defaultEventValue = { target: 16 };

export const getDefaultSchedule = ({ productProps }) => {
    if (productProps.get('maxEvents') === 4) {
        return {
            monday: [
                { value: { target: 20 }, start: 390 },
                { value: { target: 7 }, start: 510 },
                { value: { target: 20 }, start: 990 },
                { value: { target: 7 }, start: 1320 }
            ],
            tuesday: [
                { value: { target: 20 }, start: 390 },
                { value: { target: 7 }, start: 510 },
                { value: { target: 20 }, start: 990 },
                { value: { target: 7 }, start: 1320 }
            ],
            wednesday: [
                { value: { target: 20 }, start: 390 },
                { value: { target: 7 }, start: 510 },
                { value: { target: 20 }, start: 990 },
                { value: { target: 7 }, start: 1320 }
            ],
            thursday: [
                { value: { target: 20 }, start: 390 },
                { value: { target: 7 }, start: 510 },
                { value: { target: 20 }, start: 990 },
                { value: { target: 7 }, start: 1320 }
            ],
            friday: [
                { value: { target: 20 }, start: 390 },
                { value: { target: 7 }, start: 510 },
                { value: { target: 20 }, start: 990 },
                { value: { target: 7 }, start: 1320 }
            ],
            saturday: [
                { value: { target: 20 }, start: 390 },
                { value: { target: 7 }, start: 510 },
                { value: { target: 20 }, start: 990 },
                { value: { target: 7 }, start: 1320 }
            ],
            sunday: [
                { value: { target: 20 }, start: 390 },
                { value: { target: 7 }, start: 510 },
                { value: { target: 20 }, start: 990 },
                { value: { target: 7 }, start: 1320 }
            ]
        };
    } else {
        return {
            monday: [
                { value: { target: 20 }, start: 390 },
                { value: { target: 7 }, start: 510 },
                { value: { target: 7 }, start: 720 },
                { value: { target: 7 }, start: 840 },
                { value: { target: 20 }, start: 990 },
                { value: { target: 7 }, start: 1320 }
            ],
            tuesday: [
                { value: { target: 20 }, start: 390 },
                { value: { target: 7 }, start: 510 },
                { value: { target: 7 }, start: 720 },
                { value: { target: 7 }, start: 840 },
                { value: { target: 20 }, start: 990 },
                { value: { target: 7 }, start: 1320 }
            ],
            wednesday: [
                { value: { target: 20 }, start: 390 },
                { value: { target: 7 }, start: 510 },
                { value: { target: 7 }, start: 720 },
                { value: { target: 7 }, start: 840 },
                { value: { target: 20 }, start: 990 },
                { value: { target: 7 }, start: 1320 }
            ],
            thursday: [
                { value: { target: 20 }, start: 390 },
                { value: { target: 7 }, start: 510 },
                { value: { target: 7 }, start: 720 },
                { value: { target: 7 }, start: 840 },
                { value: { target: 20 }, start: 990 },
                { value: { target: 7 }, start: 1320 }
            ],
            friday: [
                { value: { target: 20 }, start: 390 },
                { value: { target: 7 }, start: 510 },
                { value: { target: 7 }, start: 720 },
                { value: { target: 7 }, start: 840 },
                { value: { target: 20 }, start: 990 },
                { value: { target: 7 }, start: 1320 }
            ],
            saturday: [
                { value: { target: 20 }, start: 390 },
                { value: { target: 7 }, start: 510 },
                { value: { target: 7 }, start: 720 },
                { value: { target: 7 }, start: 840 },
                { value: { target: 20 }, start: 990 },
                { value: { target: 7 }, start: 1320 }
            ],
            sunday: [
                { value: { target: 20 }, start: 390 },
                { value: { target: 7 }, start: 510 },
                { value: { target: 7 }, start: 720 },
                { value: { target: 7 }, start: 840 },
                { value: { target: 20 }, start: 990 },
                { value: { target: 7 }, start: 1320 }
            ]
        };
    }
};



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/schedule-type/heating/index.js